import { CombinedKeyMap } from 'app/libs/combined-key-map/combined-key-map';

import { TTariffProfileGrid } from '../../../core/tariff-profile-grid';
import { TTariffType } from '../../../core/tariff-type';
import { TTariffZone } from '../../../core/tariff-zone';
import { TTerminalType } from '../../../core/terminal-type';
import { TariffProfileRulesRecord } from './types';

type RecordKeys = {
  terminalTypeId: TTerminalType['id'] | null;
  tariffTypeId: TTariffType['id'];
  zoneId: TTariffZone['id'];
};

export const createDataMapTariffProfile = (data: TTariffProfileGrid) => {
  // 0. Create key builder for DataMap
  const createCombinedKeyMapKeyer = CombinedKeyMap.createKeyBuilder<RecordKeys>(
    ['tariffTypeId', 'terminalTypeId', 'zoneId'],
  );
  type DataMapKey = ReturnType<typeof createCombinedKeyMapKeyer>;

  // 1. Create empty records with all possible combinations based on train type, tariff type and zone

  type EmptyRecords = Array<[key: DataMapKey, value: TariffProfileRulesRecord]>;

  // 1.1 Initialize empty array for all possible combinations.
  // Will be used to create Map
  const emptyRecords: EmptyRecords = [];

  // 1.2 Create all possible combinations
  data.terminalTypes.forEach((terminalType) => {
    data.tariffTypes.forEach((tariffType) => {
      data.tariffZones.forEach((zone) => {
        const ids: RecordKeys = {
          terminalTypeId: terminalType.id,
          tariffTypeId: tariffType.id,
          zoneId: zone.id,
        };

        const record: TariffProfileRulesRecord = {
          isEmpty: true, // for differ new records and existing
          terminalType,
          tariffType,
          zone,
          rule: null,
          // rule: {
          //   zoneId: zone.id,
          //   tariffTypeId: tariffType.id,
          //   terminalTypeId: null,
          //   type: null,
          //   amount: null,
          //   percent: null,
          // },
        };

        const key = createCombinedKeyMapKeyer(ids);

        emptyRecords.push([key, record]);
      });
    });
  });

  // 2. Create Map with empty records
  const emptyDataMap = new Map(emptyRecords);

  // 3. Fill Map with existing records from server
  data.tariffProfile.rules.forEach((rule) => {
    const ids: RecordKeys = {
      terminalTypeId: rule.terminalTypeId,
      tariffTypeId: rule.tariffTypeId,
      zoneId: rule.zoneId,
    };

    const key = createCombinedKeyMapKeyer(ids);
    const existingRecord = emptyDataMap.get(key) as TariffProfileRulesRecord; // all possible combinations are created, so it will be always found
    const recordValue: TariffProfileRulesRecord = {
      ...existingRecord,
      isEmpty: false,
      rule,
    };

    emptyDataMap.set(key, recordValue);
  });

  // 4. Initiate CombinedKeyMap
  const combinedKeyMap = new CombinedKeyMap({
    data: emptyDataMap,
    keyBuilder: createCombinedKeyMapKeyer,
  });

  return combinedKeyMap;
};

export type TariffProfileDataMap = ReturnType<
  typeof createDataMapTariffProfile
>;
